const truthyStrings = new Set(["yes", "true", "1", "y", "billed", "paid"]);
const falsyStrings = new Set(["no", "false", "0", "n", "unbilled", "pending", ""]);

const YES_META = {
    color: "#0F9960",
    background: "rgba(15, 153, 96, 0.12)",
    border: "rgba(15, 153, 96, 0.45)",
};

const NO_META = {
    color: "#DB3737",
    background: "rgba(219, 55, 55, 0.12)",
    border: "rgba(219, 55, 55, 0.45)",
};

const normalizePrimitive = (value) => {
    if (typeof value === "string") {
        const trimmed = value.trim().toLowerCase();
        if (truthyStrings.has(trimmed)) {
            return true;
        }
        if (falsyStrings.has(trimmed)) {
            return false;
        }
        return Boolean(trimmed);
    }
    if (typeof value === "number") {
        if (Number.isNaN(value)) {
            return false;
        }
        return value !== 0;
    }
    if (typeof value === "boolean") {
        return value;
    }
    return Boolean(value);
};

export const resolveIsBilledValue = (value) => {
    if (Array.isArray(value)) {
        if (value.length === 0) {
            return false;
        }
        return resolveIsBilledValue(value[0]);
    }
    if (typeof value === "object" && value !== null) {
        if ("isBilled" in value) {
            return resolveIsBilledValue(value.isBilled);
        }
        if ("value" in value) {
            return resolveIsBilledValue(value.value);
        }
        // Objects without an explicit isBilled/value flag should be treated as not billed
        return false;
    }
    return normalizePrimitive(value);
};

export const getIsBilledLabel = (value) => {
    return resolveIsBilledValue(value) ? "Yes" : "No";
};

export const getIsBilledPill = (value) => {
    const isBilled = resolveIsBilledValue(value);
    const palette = isBilled ? YES_META : NO_META;
    const label = isBilled ? "Yes" : "No";
    return `<span style="display:inline-flex;align-items:center;justify-content:center;padding:2px 10px;border-radius:999px;font-size:11px;font-weight:600;color:${palette.color};background:${palette.background};border:1px solid ${palette.border};text-transform:none;line-height:1;">${label}</span>`;
};


